import { getIsLawyerAndUser } from 'Utils/lawyers';
import { useAppSelector } from './useAppSelector';

export const useIsLawyer = () => {
  const imposter = useAppSelector(({ imposter }) => imposter);
  return getIsLawyerAndUser() ? imposter.isLawyerArea : imposter.isLawyer;
};
